import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { setFocus } from '../../misc/tools';
import { Window508Type } from '../../scenarios/MedsurgBaseScenario';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

import './SbarUI.css'
import SimpleFeedbackUI from './SimpleFeedbackUI';

var innerData = {
	windows: [
		{
			title: 'Situation',
			hasBeenSelectedAtSomePoint: false
		},
		{
			title: 'Background',
			hasBeenSelectedAtSomePoint: false
		},
		{
			title: 'Assessment',
			hasBeenSelectedAtSomePoint: false
		},
		{
			title: 'Recommendations',
			hasBeenSelectedAtSomePoint: false
		}
	]
}

const SbarUI = (props: UIProperties<SbarUIConfig>) => {
	const [currentWindowIndx, setCurrentWindowIndx] = useState(-1);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [showFeedback, setShowFeedback] = useState(false);
	const [hasIncorrectChoices, setHasIncorrectChoices] = useState(false);
	var sQuizData: SbarUIMultipleChoiceConfig = null;
	var rQuizData: SbarUIMultipleChoiceConfig = null;

	const setWindow = (indx: number) => {
		innerData.windows[indx].hasBeenSelectedAtSomePoint = true;
		setFocus('sbar-title')
		setCurrentWindowIndx(indx);
	};

	if(currentWindowIndx === -1) {
		setWindow(0);
		return;
	}

	const submitAndEvaluate = () => {
		setHasIncorrectChoices(props.parameters.s.options.concat(props.parameters.r.options)
								.filter(o => (o.isCorrect && !o.isSelected) || (!o.isCorrect && o.isSelected)).length > 0);
		props.parameters.s.isSubmitted = true;
		props.parameters.r.isSubmitted = true;
		if(rQuizData) {
			rQuizData.isSubmitted = true;
		}

		if(sQuizData) {
			sQuizData.isSubmitted = true;
		}
		setIsSubmitted(true);
		setShowFeedback(true);
		if(props.parameters.onSetWindow) {
			props.parameters.onSetWindow(Window508Type.FeedbackUI);
		}

		if(props.parameters.onSubmitted) {
			props.parameters.onSubmitted(props.parameters);
		}
	};

	const getOuterData = () => {
		switch(currentWindowIndx) {
			case 0:
				return props.parameters.s;
			case 1:
				return props.parameters.basic;
			case 2:
				return props.parameters.nurses;
			case 3:
				return props.parameters.r;
		}
	}

	const getWindowContent = () => {
		switch(currentWindowIndx) {
			case 0:
				return getSWindowContent();
			case 1:
				return getBWindowContent();
			case 2:
				return getAWindowContent();
			case 3:
				return getRWindowContent();
		}

		return (null);
	}

	const getSWindowContent = () => {
		var data = (props.parameters.s as SbarUIMultipleChoiceConfig);
		return (
			<div className='modal-disable-select'>
				<p tabIndex={0} style={{
					margin: '0',
    				color: 'rgb(214, 136, 19)',
					position: 'absolute',
					top: '10px',
					left: '10px',
					fontSize: '20pt',
					fontWeight: 'bold'
				}}>Please select from the options below to communicate the situation.</p>
				<div style={{
					    position: 'absolute',
						top: '50px',
						left: '10px',
						width: '1110px',
						pointerEvents: 'none'
				}}>
					<MultipleChoice options={sQuizData ? sQuizData.options : data.options} isSubmitted={isSubmitted} onOptionSelected={(result: SbarUIMultipleChoiceConfig) => {
						sQuizData = result;
						if(data.onOptionSelected) {
							data.onOptionSelected(result);
						}
					}} onForceUpdate={() => {
						setForceUpdate(!forceUpdate)
					}}></MultipleChoice>
				</div>
			</div>
		)
	}

	const drawUnorderedList = (items: string[]) => {
		return (
			<ul style={{
				margin: '0',
				marginBottom: '10px'
			}}>
				{items.length > 0 ? items.map((item: string, index: number) => {
					return (
						<li tabIndex={0} key={Tools.generateGuid()}>
							{item}
						</li>
					);
				}) : (<li>NA</li>)}
			</ul>
		);
	}

	const getBWindowContent = () => {
		var data = props.parameters.basic
		return data.map((item: SbarUIBackgroundConfig, index: number) => {
			return (
				<div>
					<p tabIndex={0} className="pr-basic-item-title big-description-font">{item.title}</p>
					<p tabIndex={0} className="pr-basic-item-description regular-description-font" dangerouslySetInnerHTML={{ __html: item.description }}></p>
				</div>
			);
		})
	}

	const getAWindowContent = () => {
		var data = props.parameters.nurses;

		return data.map((item: SbarUIAssessmentConfig, index: number) => {
			return (
				<div>
					<p tabIndex={item.visit ? 0 : -1} className="pr-basic-item-visit big-description-font">{item.visit}</p>
					{item.lineBreak ? (<hr style={{
						backgroundColor: 'rgb(214, 136, 19)',
						height: '2px'
					}} />):(null)}
					<p tabIndex={item.title ? 0 : -1} className="pr-basic-item-title big-description-font">{item.title}</p>
					<p tabIndex={item.header ? 0 : -1} className="pr-basic-item-header" dangerouslySetInnerHTML={{ __html: item.header }}></p>
					<ul tabIndex={item.list ? 0 : -1} className="pr-basic-item-list" style={{
						listStyleType: 'disc',
					}} dangerouslySetInnerHTML={{ __html: item.list }}></ul>
				</div>
			)
		})
	}

	const getRWindowContent = () => {
		var data = (props.parameters.r as SbarUIMultipleChoiceConfig);
		return (
			<div>
				<p tabIndex={0} style={{
					margin: '0',
    				color: 'rgb(214, 136, 19)',
					position: 'absolute',
					top: '10px',
					left: '10px',
					fontSize: '20pt',
					fontWeight: 'bold'
				}}>Please select from the recommendations below</p>
				<div style={{
					    position: 'absolute',
						top: '50px',
						left: '10px',
						width: '1110px',
						height: '390px',
						pointerEvents: 'none'
				}}>
					<MultipleChoice options={rQuizData ? rQuizData.options : data.options} isSubmitted={isSubmitted} onOptionSelected={(result: SbarUIMultipleChoiceConfig) => {
						rQuizData = result;
						if(data.onOptionSelected) {
							data.onOptionSelected(result);
						}
					}} onForceUpdate={() => {
						setForceUpdate(!forceUpdate)
					}}></MultipleChoice>
				</div>
			</div>
		)
	}

	var currentWindow = {
		innerData: innerData.windows[currentWindowIndx],
		outerData: getOuterData()
	};

	const displayFeedback = () => {
		return (
			<SimpleFeedbackUI text={ hasIncorrectChoices ? props.parameters.incorrectFeedback : props.parameters.correctFeedback} onClose={() => {
				if(props.parameters.onSetWindow) {
					props.parameters.onSetWindow(Window508Type.SbarUI);
				}
		
				setShowFeedback(false);
			}}></SimpleFeedbackUI>
		)
	};

	return (
		<div id={props.id} className="modal-bg fade-in-animation in-game-ui-container ui-top-most-container modal-bg">
			<div style={{
				width: '92%',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}} id={'first-object-sbarui'} tabIndex={0} aria-label='s bar'>
				<img src="./assets/images/general/components/sbar/sbar_bg.png"/>
				<div style={{
					position: 'absolute',
					top: '61px',
					left: '50%',
					width: '97%',
					height: '74px',
					transform: 'translate(-50%, 0)'
				}}>
					<div style={{
						position: 'absolute',
						top: '0',
						width: '280px',
						height: '100%',
						display: 'grid',
						gridTemplateColumns: 'auto auto auto auto'
					}}>
						<SbarTabButton ariaLbl='s' isChecked={innerData.windows[0].hasBeenSelectedAtSomePoint} uncheckedMain="button_sbar_s_main" uncheckedDown="button_sbar_s_down" 
										isSelected={currentWindowIndx === 0} checkedMain= "button_sbar_s_checked_main" checkedDown="button_sbar_s_checked_down" onClick={() => setWindow(0)}></SbarTabButton>

						<SbarTabButton ariaLbl='b' isChecked={innerData.windows[1].hasBeenSelectedAtSomePoint} uncheckedMain="button_sbar_b_main" uncheckedDown="button_sbar_b_down" 
										isSelected={currentWindowIndx === 1} checkedMain= "button_sbar_b_checked_main" checkedDown="button_sbar_b_checked_down" onClick={() => setWindow(1)}></SbarTabButton>

						<SbarTabButton ariaLbl='a' isChecked={innerData.windows[2].hasBeenSelectedAtSomePoint} uncheckedMain="button_sbar_a_main" uncheckedDown="button_sbar_a_down" 
										isSelected={currentWindowIndx === 2} checkedMain= "button_sbar_a_checked_main" checkedDown="button_sbar_a_checked_down" onClick={() => setWindow(2)}></SbarTabButton>

						<SbarTabButton ariaLbl='r' isChecked={innerData.windows[3].hasBeenSelectedAtSomePoint} uncheckedMain="button_sbar_r_main" uncheckedDown="button_sbar_r_down" 
										isSelected={currentWindowIndx === 3} checkedMain= "button_sbar_r_checked_main" checkedDown="button_sbar_r_checked_down" onClick={() => setWindow(3)}></SbarTabButton>
					</div>
					<p tabIndex={0} id='sbar-title' className="title-font" style={{
						position: 'absolute',
						top: '50%',
						left: '290px',
						margin: 0,
						transform: 'translate(0, -50%)',
						fontSize: '30pt',
						fontWeight: 'normal'
					}}>{currentWindow.innerData.title}</p>
				</div>
				
				<div style={{
					position: 'absolute',
					top: '160px',
					left: '47%',
					transform: 'translate(-50%, 0)',
					width: '90%',
					height: '70%',
					borderStyle: 'solid',
					borderColor: 'gray',
					borderWidth: '5px',
					padding: '10px',
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
					overflow: 'auto'
				}} tabIndex={0} aria-label={'content'}>
					{getWindowContent()}
				</div>

				<div style={{
					position: 'absolute',
					top: '88%',
					width: '100%',
				}}>
					{currentWindowIndx > 0 ? (<GeneralButtonWithText parameters= {{
						srcIdle: './assets/images/general/components/sbar/button_sbar_next_main.png',
						srcHighlight: './assets/images/general/components/sbar/button_sbar_next_down.png',
						highlightOnHover: true,
						text: 'Previous',
						top: '4px',
						left: '5%',
						width: '147.33px',
						customImgStyle: {
							transform: 'scaleX(-1)',
							left: '-5px',
							maxWidth: 'unset',
							width: '100%',
							height: '100%'
						},
						customTextStyle: {
						},
						onClicked: () => {
							setWindow(currentWindowIndx - 1);
						}
					}}/>) : (null)}

					{!isSubmitted && innerData.windows.length === innerData.windows.filter(w => w.hasBeenSelectedAtSomePoint).length ? (<GeneralButtonWithText parameters= {{
						srcIdle: './assets/images/general/components/sbar/button_sbar_submit_main.png',
						srcHighlight: './assets/images/general/components/sbar/button_sbar_submit_down.png',
						highlightOnHover: true,
						text: 'Submit',
						top: '7px',
						left: '40%',
						width: '187.33px',
						customImgStyle: {
							maxWidth: 'unset',
							width: '100%',
							height: '100%'
						},
						customTextStyle: {
						},
						onClicked: () => {
							submitAndEvaluate();
						}
					}}/>) : (null)}

					{isSubmitted && innerData.windows.length === innerData.windows.filter(w => w.hasBeenSelectedAtSomePoint).length ? (<GeneralButtonWithText parameters= {{
						srcIdle: './assets/images/general/components/sbar/button_sbar_submit_main.png',
						srcHighlight: './assets/images/general/components/sbar/button_sbar_submit_down.png',
						highlightOnHover: true,
						text: 'Done',
						top: '7px',
						left: '40%',
						width: '187.33px',
						customImgStyle: {
							maxWidth: 'unset',
							width: '100%',
							height: '100%'
						},
						customTextStyle: {
						},
						onClicked: () => {
							var el = document.getElementById(props.id);
							el.classList.remove('fade-in-animation');
							el.classList.add('fade-out-animation');
							setTimeout(() => {
								if(props.parameters.onClose) {
									props.parameters.onClose(props.parameters);
								}
							}, 500);
						}
					}}/>) : (null)}

					{currentWindowIndx < innerData.windows.length - 1 ? (<GeneralButtonWithText parameters= {{
						srcIdle: './assets/images/general/components/sbar/button_sbar_next_main.png',
						srcHighlight: './assets/images/general/components/sbar/button_sbar_next_down.png',
						highlightOnHover: true,
						text: 'Next',
						top: '4px',
						left: '80%',
						width: '147.33px',
						customImgStyle: {
							maxWidth: 'unset',
							width: '100%',
							height: '100%'
						},
						customTextStyle: {
						},
						onClicked: () => {
							setWindow(currentWindowIndx + 1);
						}
					}}/>) : (null)}
				</div>
				
				{showFeedback ? displayFeedback() : (null)}

				{/* <p tabIndex={0} id={'last-object-sbarui'} aria-label='end of content'></p> */}
				
			</div>
		</div>
	);

};

const SbarTabButton = (props: SbarUIButtonConfig) => {
	const [isMouseOver, setIsMouseOver] = useState(false);
	const baseUrl = './assets/images/general/components/sbar/';
	const extension = '.png';

	return (
		<div style={{
			position: 'relative'
		}} onMouseOver={() => {
			if(!isMouseOver) {
				setIsMouseOver(true);
			}
		}} onMouseEnter={() => {
			var rollOverAudio = document.getElementById('button-rollover');
			if(!globals.isMuted) {
				(rollOverAudio as any).play();
			}
		}} onMouseOut={() => {
			if(isMouseOver) {
				setIsMouseOver(false);
			}
		}}>
			<GeneralButton parameters= {{
				srcIdle: baseUrl + (props.isChecked ? props.checkedMain : props.uncheckedMain) + extension,
				srcHighlight: baseUrl + (props.isChecked ? props.checkedDown : props.uncheckedDown) + extension,
				srcDisabled: null,
				shouldLeaveOn: props.isSelected,
				ariaLbl: props.ariaLbl,
				top: '0',
				left: '0',
				width: '75.33px',
				highlightOnHover: true,
				isDisabled: false,
				onClicked: props.onClick
			}}/>
		</div>
	);

};

const MultipleChoice = (props: SbarUIMultipleChoiceConfig) => {
	const baseUrl = './assets/images/general/components/sbar/';
	const extension = '.png';
	const state_button_answer_main = 'button_answer_main';
	const state_button_answer_down = 'button_answer_down';
	const state_button_answer_down_green = 'button_answer_down_green';
	const state_button_answer_downchecked_green = 'button_answer_downchecked_green';
	const state_button_answer_down_red = 'button_answer_down_red';
	return (
		<div style={{
			position: 'relative',
			display: 'grid',
			gridTemplateColumns: 'auto auto',
			width: '100%',
			pointerEvents: 'none'
		}}>
			{props.options.map((o: SbarMultipleChoiceOptionConfig, indx: number) => {
				var row = Math.floor(indx / 2) + 1;
				var padding = 20;
				// var height = (81 * row) + padding + 'px';
				var height = '101px';

				var getCorrectImg = () => {
					var src = state_button_answer_main;

					if(o.isCorrect) {
						if(o.isSelected) {
							src = state_button_answer_downchecked_green;
						} else {
							src = state_button_answer_down_green;
						}
					} else {
						if(o.isSelected) {
							src = state_button_answer_down_red;
						} else {
							src = state_button_answer_main;
						}
					}

					return src;
				}

				if(props.isSubmitted) {
					return(
						<div style={{
							position: 'relative',
							height: height,
							pointerEvents: 'none'
						}} key={Tools.generateGuid()}>
							<div style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								width: '475.33px',
								height: height,
								transform: 'translate(-50%, -50%)',
								pointerEvents: 'all'
							}}>
								<GeneralButtonWithText parameters= {{
									srcIdle: baseUrl + getCorrectImg() + extension,
									ariaLbl: (() => {
										var result = o.text + '. ';
										if(o.isCorrect) {
											if(o.isSelected) {
												result += 'this option was selected and is correct';
											} else {
												result += 'this option was not selected but is correct';
											}
										} else {
											if(o.isSelected) {
												result += 'this option was selected but is incorrect';
											} else {
												result += 'this option was not selected and is not correct';
											}
										}
										return result;
									})(),
									srcHighlight: baseUrl + getCorrectImg() + extension,
									shouldLeaveOn: true,
									top: '0',
									left: '0',
									width: '475.33px',
									highlightOnHover: false,
									text: o.text,
									customImgStyle: {
										maxWidth: 'unset',
										width: '100%',
										height: '100%'
									},
									customBttnStyle: {
										width: '100%'
									},
									customTextStyle: {
										left: '100px',
										transform: 'translate(0, -50%)',
										width: '340px',
										fontSize: '19pt'
									},
									onClicked: () => {
									}
								}}/>
							</div>
						</div>
						
					);
				} else {
					return(
						<div style={{
							position: 'relative',
							height: height,
							pointerEvents: 'none'
						}} key={Tools.generateGuid()}>
							<div style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								width: '475.33px',
								height: height,
								transform: 'translate(-50%, -50%)',
								pointerEvents: 'all'
							}}>
								<GeneralButtonWithText parameters= {{
									srcIdle: baseUrl + state_button_answer_main + extension,
									srcHighlight: baseUrl + state_button_answer_down + extension,
									id:'sbar-s-' + indx,
									ariaLbl:  o.text + '. ' + (o.isSelected ? `selected` : 'not selected'),
									shouldLeaveOn: o.isSelected,
									top: '0',
									left: '0',
									width: '475.33px',
									highlightOnHover: false,
									text: o.text,
									customImgStyle: {
										maxWidth: 'unset',
										width: '100%',
										height: '100%'
									},
									customBttnStyle: {
										width: '100%'
									},
									customTextStyle: {
										left: '100px',
										transform: 'translate(0, -50%)',
										width: '340px',
										fontSize: '19pt'
									},
									onClicked: () => {
										if(typeof props.options[indx].isSelected === 'undefined') {
											props.options[indx].isSelected = false;
										}
										props.options[indx].isSelected = !props.options[indx].isSelected;
										props.onOptionSelected(props);
										props.onForceUpdate();
										setFocus('sbar-s-' + indx);
									}
								}}/>
							</div>
						</div>
						
					);
				}
			})}
		</div>
	);

};

export interface SbarUIConfig extends BaseConfig {
	s: SbarUIMultipleChoiceConfig;
	basic: SbarUIBackgroundConfig[];
	nurses: SbarUIAssessmentConfig[];
	r: SbarUIMultipleChoiceConfig;

	correctFeedback: string;
	incorrectFeedback: string;

	onClose: (result: SbarUIConfig) => void;
	onSubmitted: (result: SbarUIConfig) => void;
	onSetWindow?: (window: Window508Type) => void;

}

export interface SbarUIBackgroundConfig  {
	title: string;
	description?: string;
}

export interface SbarUIAssessmentConfig {
	visit: string;
	title: string;
	header: string;
	list: string;
	lineBreak?: boolean;
	//visits: SbarUIAssessmentVisitConfig[];
}

export interface SbarUIAssessmentVisitConfig {
	assessmentAreas: SbarUIAssessmentAreaConfig[];
}

export interface SbarUIAssessmentAreaConfig {
	title: string;
	sections: SbarUIAssessmentAreaSectionConfig[];
}

export interface SbarUIAssessmentAreaSectionConfig {
	title: string;
	items: string[];
}

export interface SbarUIMultipleChoiceConfig {
	options: SbarMultipleChoiceOptionConfig[];
	isSubmitted?: boolean;
	maxPoints?: number;
	onOptionSelected?: (result: SbarUIMultipleChoiceConfig) => void;
	onForceUpdate?: () => void;
}

export interface SbarMultipleChoiceOptionConfig {
	text: string;
	isCorrect: boolean;
	isSelected?: boolean;
}

export interface SbarUIButtonConfig {
	isChecked: boolean;
	isSelected: boolean;
	uncheckedMain: string;
	uncheckedDown: string;
	checkedMain: string;
	checkedDown: string;
	ariaLbl: string;
	onClick: () => void;
}

export default SbarUI;